import * as constants from '../constants';

const initialState = {
    results: [],
    count: 0,
    removeId: 0
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCalculatorsMordovia.success: {
            return action.payload;
        }

        case constants.getCalculatorsMordovia.error: {
            return initialState;
        }

        default:
            return state;
    }
}
